var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 19.5,
    stroke: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_146943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4885 30.2244C42.4885 29.2412 42.4069 28.5236 42.2301 27.7795H30.739V32.2175H37.484C37.3481 33.3204 36.6138 34.9814 34.9819 36.0975L34.959 36.246L38.5923 38.9962L38.844 39.0208C41.1558 36.9346 42.4885 33.8652 42.4885 30.2244Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.739 41.9176C34.0435 41.9176 36.8177 40.8545 38.844 39.0209L34.9819 36.0976C33.9484 36.8018 32.5612 37.2934 30.739 37.2934C27.5025 37.2934 24.7555 35.2074 23.7763 32.324L23.6328 32.3359L19.8548 35.1927L19.8054 35.3269C21.818 39.2334 25.9521 41.9176 30.739 41.9176Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7763 32.324C23.518 31.58 23.3684 30.7826 23.3684 29.9589C23.3684 29.135 23.518 28.3378 23.7627 27.5937L23.7559 27.4352L19.9306 24.5325L19.8055 24.5906C18.976 26.2117 18.5 28.0322 18.5 29.9589C18.5 31.8855 18.976 33.7059 19.8055 35.327L23.7763 32.324Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.739 22.624C33.0372 22.624 34.5875 23.594 35.4714 24.4046L38.9255 21.1093C36.8042 19.1826 34.0435 18 30.739 18C25.9521 18 21.818 20.6841 19.8054 24.5906L23.7627 27.5936C24.7555 24.7102 27.5025 22.624 30.739 22.624Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_146943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBtn);
export default __webpack_public_path__ + "static/media/google-btn.f5fe71749bb39a1bb60d33616547537c.svg";
export { ForwardRef as ReactComponent };